import { render } from "./Champ_Date.vue?vue&type=template&id=5f8419f5"
import script from "./Champ_Date.vue?vue&type=script&lang=js"
export * from "./Champ_Date.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__